export default __webpack_public_path__ + "static/media/505.bd8f2945.jpg";